import ObjArrUtils from '@/utils/ObjArrUtils'

import { Base, BREAD, error } from '@/store/base/module'
import BUSINESS_DATA from '@/configs/businessConstants'

const module = {
  // `app` prefix is required to avoid name conflicts with other modules'
  // and to make it easier to identify the module in the store.
  state: {
    appHeaderTitle: null,
    appHeaderColor: null,
    appDocumentTitle: BUSINESS_DATA.APP_TITLE,
    appFullScreen: false,
    // Give string name to display sub header
    appSubHeader: undefined,

    previousRouteInfo: null
  },

  getters: {
    getAppHeaderTitle(state) {
      return state.appHeaderTitle
    },

    getAppHeaderColor(state) {
      return state.appHeaderColor
    },

    getAppDocumentTitle(state) {
      return state.appDocumentTitle
    },

    getAppFullScreen(state) {
      return state.appFullScreen
    }
  },

  mutations: {
    SET_APP_HEADER_TITLE(state, payload) {
      state.appHeaderTitle = payload
    },
    SET_APP_HEADER_COLOR(state, payload) {
      state.appHeaderColor = payload
    },
    SET_APP_DOCUMENT_TITLE(state, payload) {
      document.title = payload
      state.appDocumentTitle = payload
    },
    SET_APP_FULL_SCREEN(state, payload) {
      state.appFullScreen = payload
    },
    SET_APP_SUB_HEADER(state, payload) { state.appSubHeader = payload },
    SET_PREVIOUS_ROUTE_INFO(state, payload) {
      state.previousRouteInfo = payload
    },
  },
  actions: {

  }
}

export default ObjArrUtils.merge(Base, module)
